export const SORTING_MODE = {
    BAR: 'bar',
    LIST: 'list',
};

export const getGroupedIndexes = array =>
    Object.values(
        array.reduce((acc, element) => {
            if (element.groupBy) {
                const group = acc[element.groupBy];
                if (!group) {
                    acc[element.groupBy] = {
                        label: element.groupBy,
                        value: [element],
                    };
                } else {
                    acc[element.groupBy].value.push(element);
                }
            } else {
                acc[element.label] = element;
            }
            return acc;
        }, {}),
    );

export const hasIndexChanged = (nextIndex, currentIndex) =>
    nextIndex.some(
        nextItem =>
            currentIndex.find(oldItem => oldItem.value === nextItem.value)
                ?.isRefined !== nextItem.isRefined,
    );
